export default function Bus() {
    let events = {};

    /**
     * Get an event stack - creates it if it doesn't exist.
     *
     * @param name
     * @return {[]}
     */
    function stack(name) {
        return events[name] = (events[name] || []);
    }

    function on(event, listener) {
        if (listener) {
            stack(event).push(listener);
        } else {
            throw new Error('No listener passed to Bus.on');
        }
    }

    function off(event, listener = null) {
        if (listener) {
            const index = stack(event).indexOf(listener);

            if (index !== -1) {
                stack(event).splice(index, 1);
            }
        } else {
            events[event] = [];
        }
    }

    function emit(event, args) {
        for (const listener of stack(event)) {
            try {
                if (Array.isArray(args)) {
                    listener.apply(null, args);
                } else {
                    listener.call(null, args);
                }
            } catch (error) {
                console.error('[bus]: Error in event bus listener:', listener);
                console.error(error);
            }
        }
    }

    function destroy() {
        events = {};
    }

    return {
        destroy,
        on,
        off,
        emit
    }
}